import { formatCurrency } from '@/common/utils/formatters'
import { CompanyPriceSurveyData } from '@/features/privateCompanies/types/companyPriceSurvey.type'

export class CompanyPriceSurveyProductsTransformer {
  static tableTransformer() {
    return (companyPriceSurveyProducts: CompanyPriceSurveyData['price_survey_products']) => {
      return companyPriceSurveyProducts.map((companyPriceSurveyProduct) => ({
        ...companyPriceSurveyProduct,
        display_name: companyPriceSurveyProduct.product.display_name,
        price: companyPriceSurveyProduct.price ? formatCurrency(Number(companyPriceSurveyProduct.price)) : '',
      }))
    }
  }
}
